// mcgraw-hill: hard-coded subchapters for the Contents panel (titles in Title
// Case, even where the book prints them in capitals), keyed by the
// chapter number (as an integer, so "Ch05.pdf" is 5). Pages are 1-based pages
// of that chapter's PDF.
export interface McGrawHillSubchapter {
  title: string;
  page: number;
}

export const MCGRAW_HILL_SUBCHAPTERS: Readonly<
  Record<number, readonly McGrawHillSubchapter[]>
> = {
  1: [
    { title: 'Case Study', page: 1 },
    { title: 'The History of Pharmacology', page: 2 },
    { title: 'General Principles of Pharmacology', page: 4 },
    { title: 'Drug Development & Regulation', page: 23 },
    { title: 'Case Study Answer', page: 41 },
  ],
  4: [
    { title: 'Case Study', page: 1 },
    { title: 'Why Is Drug Biotransformation Necessary?', page: 1 },
    { title: 'The Role of Biotransformation in Drug Disposition', page: 2 },
    { title: 'Where Do Drug Biotransformations Occur', page: 4 },
    {
      title: 'Microsomal Mixed Function Oxidase System & Phase I Reactions',
      page: 5,
    },
    { title: 'Human Liver P450 Enzymes', page: 9 },
    { title: 'Phase II Reactions', page: 15 },
    { title: 'Metabolism of Drugs to Toxic Products', page: 17 },
    { title: 'Clinical Relevance of Drug Metabolism', page: 19 },
    { title: 'Case Study Answer', page: 36 },
  ],
};
